module.exports = __webpack_public_path__ + "videos/video-premium-benefit-report.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/premium/video-premium-benefit-report.mp4
// module id = 978
// module chunks = 1